<template>
    <div class="top-edit-bar" v-if="selected_items && selected_items.length > 0">
        <div class="top-edit-bar-icon fas fa-times" @click="clearSelection()"></div>
        <div class="top-edit-bar-text">{{ selected_items.length }} Selected</div>
        <div v-if="canIsolate" class="top-edit-bar-icon fa-solid fa-arrow-up-right-from-square" title="Mark as isolation" @click="markAsIsolated()"></div>
        <div class="top-edit-bar-icon fas fa-trash" @click="deleteSelectedTags()"></div>
    </div>
</template>

<script>
import { ForgeEquipment } from '@/scripts/js/forgeModels';

    export default {
        name: 'SelectionInfo',
        props: ['selected_items'],
        emits: ['delete-selection', 'clear-selection'],
        methods: {
            clearSelection() {
                this.$emit('clear-selection');
                // this.selected_items.forEach(o => o.isSelected = false);
                // this.selected_items.splice(0, this.selected_items.length);
            },
            deleteSelectedTags() {
                this.$emit('delete-selection');
            },
            markAsIsolated() {
                this.$emit('mark-isolated');
            }
        },
        computed: {
            canIsolate() {
                return this.selected_items.filter(o => o instanceof ForgeEquipment).some(o => !o.isIsolated);
            }
        }
    }
</script>

<style>
    .top-edit-bar {
        position: absolute;
        width: calc(100% - 25px);
        left: 5px;
        background-color: #545454;
        border-radius: 1px;
        display: flex;
        z-index: 2;
        height: 22px;
        padding: 6px;
        align-items: center;
        box-shadow: 2px 2px lightgrey;
        top: 2px;
        animation-name: showTopBarAnim;
        animation-duration: .5s;
    }

    @keyframes showTopBarAnim {
        0% {
            height: 0;
            padding: 0;
            display: none;
        }

        100% {
            height: 22px;
            padding: 6px;
            display: flex;
        }
    }

    .top-edit-bar-icon {
        font-size: 16px;
        color: white;
        margin: 4px;
        cursor: pointer;
    }

        .top-edit-bar-icon:hover {
            color: orange;
        }

    .top-edit-bar-text {
        font-size: 12px;
        color: white;
        flex-grow: 1;
    }
</style>
